module.exports = __webpack_public_path__ + "img/lucasfernandes_fun.f99d5083.jpg";